import {
  createRouter,
  createWebHashHistory,
  createWebHistory
} from 'vue-router'

const routes = [{
    path: '/',
    name: 'home2',
    meta: {
      title: '售后管理平台'
    },
    component: () => import('../views/index.vue')
  },
  {
    path: '/index',
    name: 'home',
    meta: {
      title: '售后管理平台'
    },
    component: () => import('../views/index.vue')
  },
  {
    path: '/help',
    name: 'help',
    meta: {
      title: '使用帮助'
    },
    component: () => import('../views/help.vue')
  },
  {
    path: '/loginWx',
    name: 'loginWx',
    meta: {
      title: '微信授权'
    },
    component: () => import('../views/loginWx.vue')
  },
  {
    path: '/repair',
    name: 'repair',
    meta: {
      title: '设备保养'
    },
    component: () => import('../views/repair.vue')
  },
  {
    path: '/service',
    name: 'service',
    meta: {
      title: '售后服务单'
    },
    component: () => import('../views/service.vue')
  },
  {
    path: '/history',
    name: 'history',
    meta: {
      title: '售后列表'
    },
    component: () => import('../views/history.vue')
  },
  {
    path: '/log',
    name: 'log',
    meta: {
      title: '售后日志'
    },
    component: () => import('../views/log.vue')
  },
  {
    path: '/logHistory',
    name: 'logHistory',
    meta: {
      title: '售后日志'
    },
    component: () => import('../views/logHistory.vue')
  },
  {
    path: '/logDetail',
    name: 'logDetail',
    meta: {
      title: '日志详情'
    },
    component: () => import('../views/logDetail.vue')
  },
  {
    path: '/reg',
    name: 'reg',
    meta: {
      title: '售服注册申请'
    },
    component: () => import('../views/reg.vue')
  },
  {
    path: '/reportHistory',
    name: 'reportHistory',
    meta: {
      title: '质检报告'
    },
    component: () => import('../views/reportHistory.vue')
  },
  {
    path: '/reportAdd',
    name: 'reportAdd',
    meta: {
      title: '新增质检报告'
    },
    component: () => import('../views/reportAdd.vue')
  },
  {
    path: '/reportShare',
    name: 'reportShare',
    meta: {
      title: '新增质检报告'
    },
    component: () => import('../views/reportShare.vue')
  },
]

const router = createRouter({
  mode: 'history',
  history: createWebHashHistory(),
  routes
})

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})

export default router
